import React, { Component } from 'react';

import Messages from '../../components/common/Toastr/messages';
import MfaSmartForm from './Form';


const Page = ({
    dataExpiracao,
    tempoEnvio,
    IdUsuario,
    Email,
    Usuario,
    redirectBack,
    prelogin
}) => {
    const goBack = () => {
        document.location.href = redirectBack || '#/';
    };

    return (
        <React.Fragment>
            <MfaSmartForm
                IdUsuario={IdUsuario}
                Email={Email}
                Usuario={Usuario}
                dataExpiracao={dataExpiracao}
                tempoEnvio={tempoEnvio}
                goBack={goBack}
                prelogin={prelogin}
            />
            <Messages />
        </React.Fragment>
    );
}

export default Page;
